import { EmployeeBasic, EmployeeName, PersonalData } from '@xpo-ltl/sdk-humanresource';

export class EmployeeModel {
  id: string;
  firstName: string;
  lastName: string;

  constructor(employeeBasic: EmployeeBasic | EmployeeName | PersonalData) {
    this.id = employeeBasic.employeeId;
    this.firstName = employeeBasic.preferredFirstName ? employeeBasic.preferredFirstName : employeeBasic.firstName;
    this.lastName = employeeBasic.lastName;
  }

  getDisplayName(): string {
    return `${this.capitalizeFirstLetter(this.firstName)} ${this.capitalizeFirstLetter(this.lastName)}`;
  }

  private capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
